import React, {useState} from "react";
import image from '../../public/img01.png';
import Markdown from "markdown-to-jsx";
import {MoveRight, X} from "lucide-react";

export function SectionItem({item}:{item:Item}){
    const [fullscreenImg, setFullscreenImg] = useState<string|null>(null);

    const handleClick = (image:FileType) => {
        if(!item.Preview_Link && !item.Preview_File) {
            setFullscreenImg(image.signedUrl);
        }
    }

    const renderImage = (image: FileType) => {
      return (
        <>
          <img
            key={item.Id}
            className={'mt-1 cursor-pointer rounded'}
            src={image.signedUrl}
            alt={image.title}
            onClick={() => handleClick(image)}
          />
        </>
      );
    };
    const renderWrappedImage = (image: FileType) => {
      if (item.Preview_Link) {
        return (
          <a href={item.Preview_Link} target={'_blank'}>
            {renderImage(image)}
            <div
              className="absolute bottom-0 left-0 truncate rounded bg-white bg-opacity-90 p-1 text-xs"
              style={{ maxWidth: '100%' }}
            >
              {new URL(item.Preview_Link).hostname}
            </div>
          </a>
        );
      } else if (item.Preview_File) {
        return (
          <a href={item.Preview_File[0]?.signedUrl} target={'_self'}>
            {renderImage(image)}
            <div
              className="absolute bottom-0 left-0 truncate rounded bg-white bg-opacity-90 p-1 text-xs"
              style={{ maxWidth: '100%' }}
            >
              {item.Preview_File[0].title}
            </div>
          </a>
        );
      } else {
        return renderImage(image);
      }
    };

    return (
        <div className={"bg-white mt-4 py-3 px-2 rounded-lg"}>
            <b className={"text-lg"}>{item.Title}</b>
            {item.Preview_picture && item.Preview_picture.map((image) => (
                <div className={"relative inline-block"} key={image.id}>
                    {renderWrappedImage(image)}
                </div>
            ))}

            {fullscreenImg && (
                <div
                    className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-60"
                    onClick={() => setFullscreenImg(null)}
                >
                    <button
                        className="absolute top-8 right-10 text-white text-3xl bg-gray-800 rounded-full p-2 hover:bg-gray-600"
                        onClick={() => setFullscreenImg(null)}
                    >
                        <X size={24}/>
                    </button>
                    <img src={fullscreenImg} alt="Fullscreen" className="max-w-full max-h-full"/>
                </div>
            )}

            <br/>
            {item.Text && <div className={"itemText text-ellipsis overflow-hidden"}>
              <Markdown className={"text-sm text-ellipsis"}>{item.Text}</Markdown>
            </div>}
            {/*{ item.URL1 &&*/}
            {/*    <div><MoveRight size={17} className={"inline"} />*/}
            {/*        <a href={""} target={"_blank"} className={"hover:underline ml-2 font-medium hover:text-pink-700 text-pink-500"}></a></div>*/}
            {/*}*/}

        </div>
    )
}